import types from '../types'

const updateOriginLatLng = (latLng) => ({
  type: types.ORIGIN_LATLNG_CHANGE,
  latLng,
})

const updateDestinationLatLng = (latLng) => ({
  type: types.DESTINATION_LATLNG_CHANGE,
  latLng,
})

const updateOriginKind = (kind) => ({
  type: types.ORIGIN_KIND_CHANGE,
  kind,
})

const updateDestinationKind = (kind) => ({
  type: types.DESTINATION_KIND_CHANGE,
  kind,
})

const updateHandoverMode = (modeId) => ({
  type: types.SET_HANDOVER_MODE,
  modeId,
})

export default {
  updateOriginKind,
  updateDestinationKind,
  updateOriginLatLng,
  updateDestinationLatLng,
  updateHandoverMode,
}
